export default __webpack_public_path__ + "static/media/logocantinho.674362ea.png";